(function() {
    'use strict';


	/*angular.module('app').filter('toArray', function() {

	    return function (obj) {
	        if (!(obj instanceof Object)) {
	            return obj;
	        }

	        return Object.keys(obj).map(function (key) {
	            return Object.defineProperty(obj[key], '$key', {__proto__: null, value: key});
	        });
	    }
	});*/


	/*angular.module('app').filter('toArray', function() {
		return function(obj) {
	    	if (!(obj instanceof Object)) return obj;
	    	return _.map(obj, function(val, key) {
	        	return Object.defineProperty(val, '$key', {__proto__: null, value: key});
	    	});
		}
	});*/


	// angular.module('angular-toArrayFilter', [])

	angular.module('app').filter('toArray', function () {
	  	return function (obj, addKey) {
    		if (!angular.isObject(obj)) return obj;
	    	if ( addKey === false ) {
	      		return Object.keys(obj).map(function(key) {
	        		return obj[key];
	      		});
	    	} else {
	      		return Object.keys(obj).map(function (key) {
	        		var value = obj[key];
	        		return angular.isObject(value) ?
	          			Object.defineProperty(value, '$key', { enumerable: false, value: key}) :
	          			{ $key: key, $value: value };
	      		});
	    	}
	  	};
	});


}());

